export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'vuestic-iconset-dashboard',
      },
    },
    {
      name: 'tickets',
      displayName: 'menu.tickets',
      meta: {
        icon: 'assignment',
      },
    },
    {
      name: 'management',
      displayName: 'menu.management',
      meta: {
        icon: 'admin_panel_settings',
      },
      children: [
        {
          name: 'users',
          displayName: 'menu.users',
          meta: {
            icon: 'people',
          },
        },
        {
          name: 'roles',
          displayName: 'menu.roles',
          meta: {
            icon: 'badge',
          },
        },
        {
          name: 'permissions',
          displayName: 'menu.permissions',
          meta: {
            icon: 'lock',
          },
        },
      ],
    },
    {
      name: 'preferences',
      displayName: 'menu.profile',
      meta: {
        icon: 'manage_accounts',
      },
    },
  ] as INavigationRoute[],
}
